import { Component, OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ManagerDetailsService } from '@manager-details/services/manager-details.service';
import { WidgetComponent } from '@dashboards/components/widget-component/widget-component';
import { ApplicationState } from '@store/application-store';
import { of, Observable } from 'rxjs';
import { takeWhile } from 'rxjs';
import { ConfirmationService } from 'primeng/api';
import { Store } from '@ngrx/store';
import { RouteContextService } from '@context/services/route-context.service';
import { ManagerDetails, ManagerDetailsArray } from '@manager-details/models/manager-details';
import { ArrayNavigator } from '@common/arrays/array-utils';
import { has } from '@details/Interfaces/details-builder';
import { LayoutOrientation } from '@common/enums/layout-orientation';
import { DetailsBuilder } from '@details/Interfaces/details-builder';
import { DetailsItemTypesArray, nameOnly, anchor } from '@details/Interfaces/details-item-types';
import { ContactUsHttpService } from '@contact-us/services/contactus-http.service';
import { UrlBuilderService } from '@common/services/url-builder.service';
import {SecureImagePipeFallbackImage} from "@common/pipes/secure-image-pipe-fallback-images";

@Component({
  selector: 'mojo-manager-details',
  templateUrl: './manager-details.component.html'
})
export class ManagerDetailsComponent extends WidgetComponent implements OnInit, OnDestroy {

  details: Observable<ManagerDetailsArray>;
  loading: Observable<boolean>;
  isAlive: boolean = true;

  navigator: ArrayNavigator<ManagerDetails> = new ArrayNavigator<ManagerDetails>([]);

  currentManager: ManagerDetails;
  Fallback = SecureImagePipeFallbackImage;

  constructor(
    private readonly sanitizer: DomSanitizer,
    protected store: Store<ApplicationState>,
    contextService: RouteContextService,
    activatedRoute: ActivatedRoute,
    protected readonly confirmationService: ConfirmationService,
    private readonly managerDetailService: ManagerDetailsService,
    private readonly urlBuilder: UrlBuilderService,
    private readonly contactUsHttp: ContactUsHttpService
  ) {
    super(store, confirmationService);
    const context = contextService.getContextFromRoute(activatedRoute);
    this.managerDetailService.load(context);
    this.details = this.managerDetailService.managerDetails.pipe(takeWhile(() => this.isAlive));
    this.details.subscribe((details) => this.setUpDetails(details));
    this.loading = this.managerDetailService.loading();
  }

  getDetailItems() {
    const detailsItemArray: DetailsItemTypesArray = [];
    if (!this.currentManager) return detailsItemArray;
    const showIm = this.showIm(this.currentManager);
    const imLabel = this.imLabel(this.currentManager);
    const b = new DetailsBuilder(null, this.currentManager);
    b
      .section(null, LayoutOrientation.Horizontal)
      .for('Office', 'Office:')
      .telFor('Phone', 'Phone:')
      .telFor('DirectPhone', 'Direct phone:')
      .telFor('MobilePhone', 'Mobile phone:')
      .mailFor('Email', 'Email:')
      .conditionalItem(showIm,
        anchor(imLabel, this.sanitizer.bypassSecurityTrustUrl(this.imHRef), this.currentManager.ImId))
      .for('Fax', 'Fax:')
      .for('ManagerCode', 'Manager Code:');


    const showProfile = has(this.currentManager.ProfileTextHeader) && has(this.currentManager.ProfileText);
    b.conditionalSection(showProfile, `${this.currentManager.ProfileTextHeader}:`, LayoutOrientation.Vertical)
      .conditionalItem(showProfile, nameOnly(this.currentManager.ProfileText));


    return b.getDetails();

  }
  private setUpDetails(details: ManagerDetailsArray) {
    this.navigator = new ArrayNavigator(details);
    this.currentManager = this.navigator.current;
  }

  has(i: any) {
    return has(i);
  }

  hasMultiple() {
    return this.navigator.hasMultipleItems;
  }

  next() {
    this.navigator.next();
    this.currentManager = this.navigator.current;
  }
  prev() {
    this.navigator.prev();
    this.currentManager = this.navigator.current;
  }

  ngOnInit() { }

  ngOnDestroy() {
    this.isAlive = false;
  }

  imLabel(d: ManagerDetails) {
    switch (d.ImService) {
      case 'Skype':
        return `Skype`;
      case 'QQ':
        return `WeChat`;
      default:
        return undefined;
    }
  }

  showIm(d: ManagerDetails) {
    return has(d.ImService) && has(d.ImId);
  }


  get imHRef() {
    const d = this.navigator.current;
    if (!this.showIm(d)) return undefined;
    let r = undefined;
    switch (d.ImService) {
      case 'Skype':
        r = `skype:${d.ImId}?call`;
        break;
      case 'QQ':
        r = `weixin://dl/chat?${d.ImId}`;
        break;
      default:
        return undefined;
    }
    return r;
  }

  imageUrl(): string {
    if (!this.currentManager) return undefined;
    return this.urlBuilder.getUrl('managers/image?code=' + this.currentManager.ManagerCode);
  }


}
